"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorldSVG = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const WorldSVG = _ref => {
  let {
    stroke = "#666687",
    width = 24,
    height = 25
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12.5",
    r: "9",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.59998 9.5H20.4",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.59998 15.5H20.4",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.5 3.5C8.06292 9.00778 8.06292 15.9922 11.5 21.5",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.5 3.5C15.9371 9.00778 15.9371 15.9922 12.5 21.5",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
exports.WorldSVG = WorldSVG;
WorldSVG.propTypes = {
  stroke: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number
};
WorldSVG.defaultProps = {
  stroke: "#666687",
  width: 24,
  height: 25
};